import React from "react";
import RankKeyword from "./RankKeyword";

/** 사이드바「순위 체크」전용 페이지 */
const RankCheck = () => <RankKeyword variant="rankCheck" />;

export default RankCheck;
